import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { IntakeWizard } from "@/components/onboarding/IntakeWizard";
import { LegalGate } from "@/components/legal/LegalGate";
import { useFamilyProfile } from "@/hooks/useProfile";
import { useMe } from "@/hooks/useMe";

export function AppShell({ children }: { children: ReactNode }) {
  const { data: me, isLoading: meLoading } = useMe();
  const family = useFamilyProfile();

  if ((meLoading && !me) || (family.isLoading && !family.data)) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-background">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
      </div>
    );
  }

  const needsIntake = me?.isOwner && !family.isError && !family.data?.onboardingCompletedAt;

  return (
    <LegalGate>
      <div className="flex min-h-screen w-full bg-background">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header />
          {me?.isAuthenticated && !me.isOwner && (
            <div className="border-b border-amber-500/20 bg-amber-500/10 px-6 py-1.5 text-center text-2xs font-medium text-amber-300">
              Confidential — All activity is logged and audited under your signed NDA
            </div>
          )}
          <main className="flex-1 overflow-y-auto px-6 py-6 lg:px-8 lg:py-8">
            <div className="mx-auto w-full max-w-6xl animate-fade-in">{children}</div>
          </main>
        </div>
        {needsIntake && <IntakeWizard fullScreen />}
      </div>
    </LegalGate>
  );
}
